import builder from './reducerBuilder'
import {
  ACTION_QUERY_APPLICATIONS_ERROR,
  ACTION_QUERY_APPLICATIONS_LOADING,
  ACTION_QUERY_APPLICATIONS_LOADED
} from '../constants'

export default builder(
  ACTION_QUERY_APPLICATIONS_LOADING,
  ACTION_QUERY_APPLICATIONS_LOADED,
  ACTION_QUERY_APPLICATIONS_ERROR)



// WEBPACK FOOTER //
// ./src/store/applicationsReducer.js